const flowAccordion = () => {
    if (!document.body || document.body.id !== "page-flow") {
        return;
    }
    const closeButtons = document.querySelectorAll("[data-flow-close]");
    closeButtons.forEach((button) => {
        button.addEventListener("click", (event) => {
            event.preventDefault();
            const details = button.closest("details.pg-flow-step");
            if (!details) return;
            details.open = false;
            const summary = details.querySelector("summary");
            if (summary) {
                summary.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        });
    });
};

export default flowAccordion;
